import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

/** Admin ou coordenação. */
export const gestaoGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.ensurePerfil().pipe(
    map((p) => {
      if (!p) {
        router.navigate(['/login'], { queryParams: { returnUrl: router.url } });
        return false;
      }
      if (p.admin || p.coordenacao) return true;
      router.navigate(['/dashboard']);
      return false;
    }),
  );
};

/** Somente administrador. */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.ensurePerfil().pipe(
    map((p) => {
      if (!p) {
        router.navigate(['/login'], { queryParams: { returnUrl: router.url } });
        return false;
      }
      if (p.admin) return true;
      router.navigate(['/dashboard']);
      return false;
    }),
  );
};

/** Minhas turmas: catequista (admin também pode abrir a tela). */
export const catequistaGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.ensurePerfil().pipe(
    map((p) => {
      if (!p) {
        router.navigate(['/login'], { queryParams: { returnUrl: router.url } });
        return false;
      }
      if (p.admin || p.catequista) return true;
      router.navigate(['/dashboard']);
      return false;
    }),
  );
};
